const initialState = {
  unsupportedBrowser: false,
};

export default function unsupportedBrowserReducer(
  state = initialState,
  action
) {
  // Was `if (action.type)` — true for EVERY dispatched action (including
  // redux-persist's REHYDRATE), so every browser was flagged unsupported
  // and every user got the 24px banner clearance as a permanent top gap.
  if (action.type === "UNSUPPORTEDBROWSER") {
    return { ...state, unsupportedBrowser: true };
  }
  return state;
}
